import axios from "axios";

const API_URL = "https://portalsales.tuku.coffee/api/a";
const WS_URL = "wss://portalsales.tuku.coffee/stream/stream";


const options = async () => {
  const getToken = JSON.parse(localStorage.getItem("verified_user")) == null ? "" : JSON.parse(localStorage.getItem("verified_user"))
 // console.log("tokenn", getToken)

  const retHeader = {
    headers: {
      'Authorization': "Bearer " + getToken.token
    }
  }
  return retHeader
};

const optionsFile = async () => {
  const getToken = JSON.parse(localStorage.getItem("verified_user")) == null ? "" : JSON.parse(localStorage.getItem("verified_user"))
 // console.log(getToken)

  const retHeader = {
    headers: {
      'Authorization': "Bearer " + getToken.token
    },
    responseType: 'arraybuffer'
  }
  return retHeader
};

const firstBranch = () => {
  const dataUser = JSON.parse(localStorage.getItem("verified_user")) === null ?
  [] : JSON.parse(localStorage.getItem("verified_user"))
      const dataBranch = dataUser ? dataUser.roleBranch[0].id : "all"

  return dataBranch
}

const firstMenu = () => {
  const dataUser = JSON.parse(localStorage.getItem("verified_user")) === null ?
  [] : JSON.parse(localStorage.getItem("verified_user"))
      const dataMenu = dataUser ? dataUser.roleMenu[0].menu_name : "Dashboard"
  return dataMenu
}

const getEmail = () => {
  const dataUser = JSON.parse(localStorage.getItem("verified_user")) === null ?
  [] : JSON.parse(localStorage.getItem("verified_user"))
      const dataEmail = dataUser ? dataUser.email : "tech@tuku.coffee"

  return dataEmail
}

const optionsBranch = () => {
  const getBranch = JSON.parse(localStorage.getItem("verified_user")) === null ?
    [] : JSON.parse(localStorage.getItem("verified_user"));
  let branchList = getBranch ? getBranch.roleBranch : null

  if (Array.isArray(branchList)) {
    branchList.sort((a, b) => a.name_branch.localeCompare(b.name_branch)); // Sort by name_branch
}

  return branchList
}
const client = axios.create({
  baseURL: API_URL,
});

const excel = API_URL;

const ApiService = {
  client,
  options,
  optionsFile,
  optionsBranch,
  firstBranch,
  firstMenu,
  getEmail,
  excel,
  WS_URL,
}

export default ApiService;
